// extracted by mini-css-extract-plugin
module.exports = {"icon":"DropdownWidget_icon__3PeBr"};